export const en = {
    'brand.name': 'beinstore',
    'email.footer.automated': 'This email was sent automatically by {brand}. Please do not reply.',
    'email.signInCode.subject': 'Your {brand} sign-in code: {code}',
    'email.signInCode.heading': 'Your sign-in code',
    'email.signInCode.intro': 'Use this code to sign in to {brand}:',
    'email.signInCode.expiry': 'It expires in {minutes, plural, one {# minute} other {# minutes}} and can be used only once.',
    'email.signInCode.ignore': 'If you did not request it, ignore this email: nobody can sign in without this code.',
    'email.signInCode.neverShare': 'The {brand} team will never ask you for this code.',
    'email.order.subject': 'Order #{number} confirmed – {store}',
    'email.order.heading': 'Thank you for your order',
    'email.order.intro': '{store} has received your order #{number}:',
    'email.order.line': '{quantity} × {title}: {amount}',
    'email.order.cashOnDelivery': 'Cash on delivery: please have the total amount ready.',
    'email.order.bankTransfer': 'Payment by bank transfer: {instructions}',
    'email.order.shipping': 'Delivery to: {address}',
    'email.order.pickup': 'Store pickup: the store will contact you when your order is ready.',
    'email.newOrder.subject': 'New order #{number} ({total})',
    'email.newOrder.heading': 'New order',
    'email.newOrder.intro': '{customer} placed order #{number} for {total} on {store}.',
    'email.newOrder.action': 'View order',
    'admin.language': 'Language',
    'admin.language.ar': 'العربية',
    'admin.language.aeb': 'تونسي',
    'admin.language.fr': 'Français',
    'admin.language.en': 'English',
    'admin.nav.home': 'Home',
    'admin.nav.account': 'My account',
    'admin.nav.security': 'Security',
    'admin.nav.signOut': 'Sign out',
    'admin.nav.label': 'Main navigation',
    'admin.nav.skip': 'Skip to content',
    'admin.nav.viewStore': 'View store',
    'admin.nav.store': 'Store navigation',
    'admin.nav.menu': 'Open menu',
    'admin.nav.closeMenu': 'Close menu',
    'admin.nav.storeHome': 'Overview',
    'admin.nav.group.sales': 'Sales',
    'admin.nav.group.catalog': 'Catalog',
    'admin.nav.group.online': 'Online store',
    'admin.nav.group.fulfilment': 'Delivery and cash',
    'admin.nav.group.settings': 'Settings',
    'admin.auth.tagline': 'Run your online store, from order to cash.',
    'admin.auth.point.orders': 'Orders, deliveries and cash on delivery in one place',
    'admin.auth.point.languages': 'Storefront in Arabic, French, Tunisian and English',
    'admin.auth.point.secure': 'Sign-in by email code, with optional two-step verification',
    'admin.loading': 'Loading…',
    'admin.save': 'Save',
    'admin.saved': 'Changes saved.',
    'admin.copy': 'Copy',
    'admin.copied': 'Copied',
    'admin.download': 'Download',
    'admin.loadMore': 'Show more',
    'storefront.reviews.title': 'Customer reviews',
    'storefront.reviews.storeTitle': 'Store reviews',
    'storefront.reviews.count': '{count, plural, one {# review} other {# reviews}}',
    'storefront.reviews.average': '{average} out of 5',
    'storefront.reviews.stars': '{rating} stars out of 5',
    'storefront.reviews.bar': '{stars} stars: {count}',
    'storefront.reviews.empty': 'No reviews yet.',
    'storefront.reviews.verified': 'Verified purchase',
    'storefront.reviews.anonymous': 'Verified customer',
    'storefront.reviews.reply': 'Reply from the store',
    'storefront.reviews.pages': 'Review pages',
    'storefront.review.title': 'Leave a review',
    'storefront.review.intro': 'Your review is published once the store approves it.',
    'storefront.review.store': 'The store (service, delivery…)',
    'storefront.review.rating': 'Your rating',
    'storefront.review.star': '{count, plural, one {# star} other {# stars}}',
    'storefront.review.comment': 'Your comment (optional)',
    'storefront.review.name': 'Your first name (shown with the review)',
    'storefront.review.submit': 'Send my review',
    'storefront.review.sent': 'Thank you! Your review will be published once approved.',
    'storefront.review.done': 'Review sent',
    'storefront.review.error.already-reviewed': 'You have already left a review.',
    'storefront.review.error.review-not-open': 'You can leave a review once the order is delivered.',
    'storefront.review.error.generic': 'Your review could not be sent. Check the fields and try again.',
    'storefront.comment.link': 'Leave a comment',
    'storefront.comment.title': 'A comment for the store',
    'storefront.comment.intro': 'An idea or a remark? Your message goes to the store and is not published.',
    'storefront.comment.message': 'Your message',
    'storefront.comment.send': 'Send',
    'storefront.comment.sent': 'Thank you, your message was sent to the store.',
    'storefront.comment.error': 'The message could not be sent. Try again later.',
    'admin.reviews.title': 'Customer reviews',
    'admin.reviews.empty': 'No reviews yet.',
    'admin.reviews.search': 'Search (text or name)',
    'admin.reviews.subject': 'About',
    'admin.reviews.subject.product': 'Product',
    'admin.reviews.subject.store': 'Store',
    'admin.reviews.rating': 'Rating',
    'admin.reviews.stars': '{rating}/5',
    'admin.reviews.status': 'Status',
    'admin.reviews.status.pending': 'To review',
    'admin.reviews.status.approved': 'Published',
    'admin.reviews.status.hidden': 'Hidden',
    'admin.reviews.filter.allStatuses': 'All statuses',
    'admin.reviews.filter.allSubjects': 'Products and store',
    'admin.reviews.filter.allRatings': 'All ratings',
    'admin.reviews.column.date': 'Date',
    'admin.reviews.column.review': 'Review',
    'admin.reviews.column.author': 'Customer',
    'admin.reviews.order': 'Order #{number}',
    'admin.reviews.open': 'Open the review of {date}',
    'admin.reviews.anonymous': 'Customer (data erased)',
    'admin.reviews.noComment': 'No comment',
    'admin.reviews.approve': 'Publish',
    'admin.reviews.hide': 'Hide',
    'admin.reviews.reply': 'Public reply',
    'admin.reviews.replyLabel': 'Your reply',
    'admin.reviews.replyHint': 'Shown under the review on the online store.',
    'admin.reviews.saveReply': 'Save the reply',
    'admin.reviews.removeReply': 'Remove the reply',
    'admin.reviews.saved': 'Review updated.',
    'admin.reviews.error.version-conflict': 'The review was changed in the meantime. Reload the page.',
    'admin.reviews.pending': '{count, plural, one {# review to check} other {# reviews to check}}',
    'admin.reviews.summary.store': 'Store',
    'admin.reviews.summary.products': 'Products',
    'admin.reviews.summary.average': '{average}/5 · {count, plural, one {# published review} other {# published reviews}}',
    'admin.reviews.summary.none': 'No published review yet',
    'admin.reviews.language': 'Language',
    'admin.comments.title': 'Comments',
    'admin.comments.intro': 'Private messages left by visitors of the online store.',
    'admin.comments.empty': 'No comments yet.',
    'admin.comments.search': 'Search the messages',
    'admin.comments.status': 'Status',
    'admin.comments.status.new': 'New',
    'admin.comments.status.handled': 'Handled',
    'admin.comments.filter.allStatuses': 'All',
    'admin.comments.column.message': 'Message',
    'admin.comments.markHandled': 'Mark handled',
    'admin.comments.reopen': 'Reopen',
    'admin.feedback.button': 'Feedback',
    'admin.feedback.title': 'Your opinion of beinstore',
    'admin.feedback.intro': 'A suggestion or a problem? The beinstore team reads every message.',
    'admin.feedback.rating': 'Your rating',
    'admin.feedback.category': 'Topic',
    'admin.feedback.category.suggestion': 'Suggestion',
    'admin.feedback.category.problem': 'Problem',
    'admin.feedback.category.other': 'Other',
    'admin.feedback.message': 'Your message',
    'admin.feedback.send': 'Send',
    'admin.feedback.sent': 'Thank you for your feedback!',
    'admin.feedback.close': 'Close',
    'admin.feedback.star': '{count, plural, one {# star} other {# stars}}',
    'admin.operator.feedback.title': 'Merchant feedback',
    'admin.operator.feedback.average': 'Average rating: {average}/5 ({count, plural, one {# response} other {# responses}})',
    'admin.operator.feedback.empty': 'No feedback yet.',
    'admin.operator.feedback.author': 'Merchant',
    'admin.operator.feedback.store': 'Store',
    'admin.operator.feedback.page': 'Page',
    'admin.operator.feedback.allCategories': 'All topics',
    'admin.operator.watch.title': 'Listings',
    'admin.operator.watch.intro': 'Watch words in every store catalog. Hide a listing or take the store offline when something is not allowed.',
    'admin.operator.watch.terms': 'Watched words',
    'admin.operator.watch.termsHint': 'One word per line, at least 4 characters. Matched in the title, description, address and tags.',
    'admin.operator.watch.termsSave': 'Save the list',
    'admin.operator.watch.termsSaved': 'Watch list saved.',
    'admin.operator.watch.suggest': 'Add suggested words',
    'admin.operator.watch.flags': 'Matching listings',
    'admin.operator.watch.recent': 'Latest listings',
    'admin.operator.watch.empty': 'Nothing matches the watch list.',
    'admin.operator.watch.noTerms': 'Save watched words to see matching listings.',
    'admin.operator.watch.matched': 'Matched',
    'admin.operator.watch.hide': 'Hide listing',
    'admin.operator.watch.confirmHide': 'Hide this listing?',
    'admin.operator.watch.hidden': 'Listing hidden.',
    'admin.operator.watch.suspend': 'Suspend store',
    'admin.operator.watch.confirmSuspend': 'Take this store offline?',
    'admin.operator.watch.suspended': 'Store suspended.',
    'admin.operator.watch.resume': 'Reopen store',
    'admin.operator.watch.resumed': 'Store reopened.',
    'admin.operator.watch.reason': 'Reason',
    'admin.operator.watch.open': 'Open listing',
    'admin.operator.watch.store': 'Store',
    'admin.operator.watch.product': 'Listing',
    'admin.operator.watch.search': 'Search listings',
    'admin.operator.watch.actions': 'Actions',
    'admin.operator.merchants': 'Merchants',
    'admin.operator.merchants.intro': 'Every owner account and the stores they run. Search, filter, export or import identity only — a file never creates a store.',
    'admin.operator.merchants.search': 'Search email, name or store',
    'admin.operator.merchants.empty': 'No merchants.',
    'admin.operator.merchants.stores': 'Stores',
    'admin.operator.merchants.stores.any': 'Any number',
    'admin.operator.merchants.stores.one': 'One store',
    'admin.operator.merchants.stores.several': 'Several stores',
    'admin.operator.merchants.presence': 'Store state',
    'admin.operator.merchants.presence.any': 'Any state',
    'admin.operator.merchants.presence.unpublished': 'Has an unpublished store',
    'admin.operator.merchants.presence.suspended': 'Has a suspended store',
    'admin.operator.merchants.presence.live': 'Has a live store',
    'admin.operator.merchants.storeCount': 'Stores',
    'admin.operator.merchants.created': 'Created',
    'admin.operator.merchants.card': 'Merchant',
    'admin.operator.merchants.otherStores': 'Other stores:',
    'admin.operator.merchants.noName': 'No display name',
    'admin.operator.merchants.csv': 'Import and export',
    'admin.operator.merchants.export': 'Export (CSV)',
    'admin.operator.merchants.import': 'Import a CSV file',
    'admin.operator.merchants.importHint': 'Columns: email (required), display_name, preferred_locale. Checked first; nothing is written until you confirm. Does not create stores or send email.',
    'admin.operator.merchants.importSummary': '{created} to create, {updated} to update. No stores are created.',
    'admin.operator.merchants.importDone': 'Import complete: {created} created, {updated} updated.',
    'admin.operator.merchants.importError.duplicate-email': 'This email appears twice in the file.',
    'admin.operator.merchants.importError.operator-account': 'This address is a platform operator. It cannot own a store.',
    'admin.grid.pagination': 'Pagination',
    'admin.grid.range': '{from}–{to} of {total}',
    'admin.grid.pageSize': 'Rows per page',
    'admin.grid.previous': 'Previous page',
    'admin.grid.next': 'Next page',
    'admin.grid.page': 'Page {page}',
    'admin.grid.reset': 'Reset',
    'admin.grid.noResults': 'No results for these criteria.',
    'admin.grid.from': 'From',
    'admin.grid.to': 'To',
    'admin.grid.filters': 'Filters',
    'admin.order.paymentMethod': 'Payment method',
    'admin.order.deliveryMethod': 'Delivery method',
    'admin.order.filter.allPaymentMethods': 'All payment methods',
    'admin.order.filter.allDeliveryMethods': 'All delivery methods',
    'admin.inventory.filter.untracked': 'Stock not tracked',
    'admin.discount.search': 'Search a code',
    'admin.discount.state': 'Situation',
    'admin.discount.state.active': 'Usable',
    'admin.discount.state.scheduled': 'Scheduled',
    'admin.discount.state.expired': 'Expired',
    'admin.discount.state.exhausted': 'Used up',
    'admin.discount.state.disabled': 'Disabled',
    'admin.discount.filter.allStates': 'All situations',
    'admin.audit.filter.allActors': 'All authors',
    'admin.audit.filter.action': 'Action containing',
    'admin.error.invalid-code': 'Incorrect code. Check it and try again.',
    'admin.error.code-expired': 'This code is no longer valid. Request a new one.',
    'admin.error.too-many-requests': 'Too many attempts. Try again in {seconds, plural, one {# second} other {# seconds}}.',
    'admin.error.email-unavailable': 'The email could not be sent. Try again in a moment.',
    'admin.error.unauthenticated': 'Your session has expired. Please sign in again.',
    'admin.error.mfa-required': 'Confirm your identity with your second factor first.',
    'admin.error.forbidden': 'Your role does not allow this action.',
    'admin.error.network': 'Connection problem. Check your network and try again.',
    'admin.error.generic': 'Something went wrong. Please try again.',
    'admin.signIn.title': 'Sign in to {brand}',
    'admin.signIn.intro': 'We email you a 6-digit code. No password needed.',
    'admin.signIn.email': 'Email address',
    'admin.signIn.sendCode': 'Send me a code',
    'admin.signIn.codeTitle': 'Check your email',
    'admin.signIn.codeIntro': 'Enter the code sent to {email}.',
    'admin.signIn.code': '6-digit code',
    'admin.signIn.continue': 'Continue',
    'admin.signIn.changeEmail': 'Use a different email',
    'admin.signIn.resend': 'Send a new code',
    'admin.mfa.verifyTitle': 'Two-step verification',
    'admin.mfa.verifyIntro': 'Enter the code shown in your authenticator app.',
    'admin.mfa.code': 'App code',
    'admin.mfa.verify': 'Verify',
    'admin.mfa.useRecovery': 'Use a recovery code',
    'admin.mfa.useApp': 'Use the authenticator app',
    'admin.mfa.recoveryCode': 'Recovery code',
    'admin.mfa.setupTitle': 'Protect your account',
    'admin.mfa.setupIntro': 'To protect your store, every sign-in asks for a code from your phone. Scan this QR code with an authenticator app.',
    'admin.mfa.qrAlt': 'QR code to scan with your authenticator app',
    'admin.mfa.manualKey': 'Can’t scan it? Enter this key: {secret}',
    'admin.mfa.activate': 'Activate',
    'admin.mfa.recoveryTitle': 'Save your recovery codes',
    'admin.mfa.recoveryIntro': 'Each code works once if you lose your phone. Keep them somewhere safe: they will not be shown again.',
    'admin.mfa.recoverySaved': 'I have saved them',
    'admin.mfa.recoveryFileName': 'beinstore-recovery-codes.txt',
    'admin.home.title': 'Hello {name}',
    'admin.home.titleAnonymous': 'Hello',
    'admin.home.stores': 'Your stores',
    'admin.home.noStores': 'You do not have access to any store yet.',
    'admin.home.auditLog': 'Audit log',
    'admin.role.owner': 'Owner',
    'admin.role.admin': 'Administrator',
    'admin.role.staff': 'Staff',
    'admin.role.support': 'Support',
    'admin.storeStatus.active': 'Active',
    'admin.storeStatus.suspended': 'Suspended',
    'admin.storeStatus.provisioning': 'Not published',
    'admin.storeStatus.closed': 'Closed',
    'admin.account.title': 'My account',
    'admin.account.email': 'Email address',
    'admin.account.displayName': 'Display name',
    'admin.account.preferredLocale': 'Preferred language (emails and interface)',
    'admin.security.title': 'Security',
    'admin.security.sessions': 'Active sessions',
    'admin.security.thisDevice': 'This device',
    'admin.security.unknownDevice': 'Unknown device',
    'admin.security.lastActive': 'Last active: {date}',
    'admin.security.revoke': 'Sign out',
    'admin.security.revokeOthers': 'Sign out of all other sessions',
    'admin.security.revokedOthers': '{count, plural, =0 {No other session.} one {# session signed out.} other {# sessions signed out.}}',
    'admin.security.recoveryCodes': 'Recovery codes',
    'admin.security.recoveryRemaining': '{count, plural, =0 {No codes left.} one {# code left.} other {# codes left.}}',
    'admin.security.regenerate': 'Generate new codes',
    'admin.security.activity': 'Recent activity',
    'admin.security.event.sign_in.code_verified': 'Sign-in code accepted',
    'admin.security.event.sign_in.completed': 'Signed in',
    'admin.security.event.sign_in.mfa_failed': 'Two-step verification failed',
    'admin.security.event.account.created': 'Account created',
    'admin.security.event.mfa.totp_enrolled': 'Authenticator app enabled',
    'admin.security.event.mfa.recovery_codes_generated': 'New recovery codes generated',
    'admin.security.event.mfa.recovery_code_used': 'Recovery code used',
    'admin.security.event.session.revoked': 'Session signed out',
    'admin.security.event.session.logged_out': 'Signed out',
    'admin.security.mfa.title': 'Two-step verification',
    'admin.security.mfa.on': 'On: every sign-in also asks for a code from your authenticator app.',
    'admin.security.mfa.off': 'Off: you sign in with the code sent by email. Turn it on to also ask for a code from your phone.',
    'admin.security.mfa.enable': 'Turn on',
    'admin.security.mfa.disable': 'Turn off',
    'admin.security.mfa.codeHint': 'Not needed within 15 minutes of a sign-in with two-step verification.',
    'admin.security.mfa.disabled': 'Two-step verification is off.',
    'admin.security.event.mfa.disabled': 'Two-step verification turned off',
    'admin.audit.title': 'Audit log',
    'admin.audit.date': 'Date',
    'admin.audit.actor': 'Actor',
    'admin.audit.action': 'Action',
    'admin.audit.target': 'Item',
    'admin.audit.ip': 'IP address',
    'admin.audit.empty': 'No events yet.',
    'admin.audit.actor.system': 'System',
    'admin.audit.actor.user': 'User',
    'admin.audit.actor.api_client': 'App',
    // --- module 4: stores, team, invitations ---
    'email.invitation.subject': 'Invitation to join {store} on {brand}',
    'email.invitation.heading': 'You are invited to join {store}',
    'email.invitation.intro': '{inviter} invites you to join the {store} team on {brand} as “{role}”.',
    'email.invitation.action': 'View the invitation',
    'email.invitation.expiry': 'This invitation expires in {days, plural, one {# day} other {# days}}.',
    'email.invitation.ignore': 'If you do not know this store, ignore this message.',
    'admin.error.conflict': 'This action conflicts with the current state (it may already be done).',
    'admin.home.createStore': 'Create a store',
    'admin.home.openStore': 'Open',
    'admin.store.new.title': 'Create your store',
    'admin.store.new.intro': 'Choose a name and an address. You will add products next.',
    'admin.store.nameIn': 'Store name ({language})',
    'admin.store.slug': 'Store address',
    'admin.store.slugHint': 'Lower-case letters, digits and hyphens. It cannot be changed later.',
    'admin.store.slugAvailable': '{host} is available.',
    'admin.store.slug.invalid': 'Use 3 to 40 lower-case letters, digits or single hyphens.',
    'admin.store.slug.reserved': 'This address is reserved.',
    'admin.store.slug.taken': 'This address is already in use.',
    'admin.store.defaultLocale': 'Main store language',
    'admin.store.enabledLocales': 'Store languages',
    'admin.store.create': 'Create the store',
    'admin.store.settings': 'Settings',
    'admin.store.team': 'Team',
    'admin.store.addresses': 'Addresses',
    'admin.store.error.defaultLocale': 'The main language must be one of the store languages and have a name.',
    'admin.team.members': 'Members',
    'admin.team.you': 'You',
    'admin.team.role': 'Role',
    'admin.team.roleFor': 'Role of {name}',
    'admin.team.remove': 'Remove',
    'admin.team.removeFor': 'Remove {name}',
    'admin.team.invitations': 'Pending invitations',
    'admin.team.noInvitations': 'No pending invitations.',
    'admin.team.invite': 'Invite someone',
    'admin.team.inviteLocale': 'Invitation language',
    'admin.team.send': 'Send invitation',
    'admin.team.sent': 'Invitation sent.',
    'admin.team.expires': 'Expires {date}',
    'admin.team.cancelInvitation': 'Cancel',
    'admin.invitation.title': 'Join {store}',
    'admin.invitation.intro': 'You are invited to join {store} as “{role}”.',
    'admin.invitation.accept': 'Accept the invitation',
    'admin.invitation.mismatch': 'This invitation was sent to {email}. Sign in with that address to accept it.',
    'admin.invitation.invalid': 'This invitation is no longer valid. Ask the store owner for a new one.',
    'admin.media.title': 'Media library',
    'admin.media.upload': 'Add images',
    'admin.media.uploadHint': 'JPEG, PNG, WebP or AVIF. Hidden photo information (GPS location, camera) is removed.',
    'admin.media.uploading': 'Uploading {done} of {total}…',
    'admin.media.uploaded': '{count, plural, one {# image added.} other {# images added.}}',
    'admin.media.empty': 'No images yet.',
    'admin.media.dimensions': '{width} × {height} px',
    'admin.media.alt': 'Image description ({language})',
    'admin.media.altHint': 'Read aloud to people with low vision and used by search engines.',
    'admin.media.edit': 'Edit',
    'admin.media.editFor': 'Edit the description of {name}',
    'admin.media.delete': 'Delete',
    'admin.media.deleteFor': 'Delete {name}',
    'admin.media.confirmDelete': 'Confirm deletion',
    'admin.media.cancel': 'Cancel',
    'admin.media.deleted': 'Image deleted.',
    'admin.media.error.payload-too-large': '{name}: the file is too large.',
    'admin.media.error.unsupported-media-type': '{name}: unsupported format. Use JPEG, PNG, WebP or AVIF.',
    'admin.media.error.invalid-image': '{name}: the image cannot be read or is too large.',
    'admin.media.error.service-unavailable': 'The media library is unavailable right now. Try again later.',
    'admin.media.error.file': 'Could not upload {name}: {message}',
    'admin.catalog.products': 'Products',
    'admin.catalog.collections': 'Collections',
    'admin.catalog.export': 'Export (CSV)',
    'admin.catalog.import': 'Import a CSV file',
    'admin.catalog.importHint': 'One row per variant. The file is checked first: nothing changes until you confirm.',
    'admin.catalog.importChecking': 'Checking the file…',
    'admin.catalog.importSummary': '{products, plural, one {# product} other {# products}}: {created} to create, {updated} to update.',
    'admin.catalog.importApply': 'Import',
    'admin.catalog.importDone': 'Import complete: {created} created, {updated} updated.',
    'admin.catalog.importErrors': 'The file has errors. Fix them and try again.',
    'admin.catalog.importErrorLine': 'Line {line}: {message}',
    'admin.catalog.importErrorCell': 'Line {line}, column {column}: {message}',
    'admin.catalog.importError.invalid-csv': 'The file is not valid CSV.',
    'admin.catalog.importError.no-rows': 'The file has no products.',
    'admin.catalog.importError.unknown-column': 'Unknown column.',
    'admin.catalog.importError.missing-column': 'Required column missing.',
    'admin.catalog.importError.too-many-rows': 'Too many rows: at most 10,000 per file.',
    'admin.catalog.importError.too-many-products': 'Too many products: at most 2,000 per file.',
    'admin.catalog.importError.required': 'Required.',
    'admin.catalog.importError.differs': 'Differs from the first row of this product.',
    'admin.catalog.importError.option-numbering': 'Options are numbered from 1 without gaps.',
    'admin.catalog.importError.invalid-amount': 'Amount in dinars with up to 3 decimals, for example 25.500.',
    'admin.catalog.importError.whole-grams': 'Weight in whole grams.',
    'admin.catalog.importError.sku-used': 'This SKU belongs to another product.',
    'admin.catalog.importError.invalid': 'Invalid value.',
    'admin.product.new': 'New product',
    'admin.product.edit': 'Edit product',
    'admin.product.search': 'Search (name, address or SKU)',
    'admin.product.statusFilter': 'Status',
    'admin.product.allStatuses': 'All',
    'admin.product.status.draft': 'Draft',
    'admin.product.status.active': 'On sale',
    'admin.product.status.archived': 'Archived',
    'admin.product.empty': 'No products yet.',
    'admin.product.noMatch': 'No products match your search.',
    'admin.product.column.product': 'Product',
    'admin.product.column.status': 'Status',
    'admin.product.column.variants': 'Variants',
    'admin.product.column.price': 'Price',
    'admin.product.column.updated': 'Updated',
    'admin.product.priceRange': '{min} – {max}',
    'admin.product.titleIn': 'Name ({language})',
    'admin.product.descriptionIn': 'Description ({language})',
    'admin.product.handle': 'Page address',
    'admin.product.handleHint': 'Lower-case letters, digits and hyphens. Leave empty to derive it from the name.',
    'admin.product.tags': 'Tags',
    'admin.product.tagsHint': 'Separated by commas.',
    'admin.product.details': 'Details',
    'admin.product.options': 'Options',
    'admin.product.optionsHint': 'For example size or colour. Each combination of values becomes a variant.',
    'admin.product.addOption': 'Add an option',
    'admin.product.removeOption': 'Remove option {number}',
    'admin.product.optionNameIn': 'Name of option {number} ({language})',
    'admin.product.optionValues': 'Values of option {number}',
    'admin.product.valueIn': 'Value {index} ({language})',
    'admin.product.addValue': 'Add a value',
    'admin.product.removeValue': 'Remove value {index}',
    'admin.product.variants': 'Prices and variants',
    'admin.product.variant': 'Variant',
    'admin.product.price': 'Price (TND)',
    'admin.product.priceFor': 'Price of {variant} (TND)',
    'admin.product.compareAt': 'Compare-at price (TND)',
    'admin.product.compareAtFor': 'Compare-at price of {variant} (TND)',
    'admin.product.sku': 'SKU',
    'admin.product.skuFor': 'SKU of {variant}',
    'admin.product.barcode': 'Barcode',
    'admin.product.weight': 'Weight (g)',
    'admin.product.tooManyVariants': 'At most {max} variants: use fewer values.',
    'admin.product.images': 'Images',
    'admin.product.noImages': 'No images.',
    'admin.product.addImages': 'Choose from the media library',
    'admin.product.closePicker': 'Close',
    'admin.product.selectImage': 'Choose {name}',
    'admin.product.moveUp': 'Move {name} up',
    'admin.product.moveDown': 'Move {name} down',
    'admin.product.removeImage': 'Remove {name}',
    'admin.product.save': 'Save product',
    'admin.product.saved': 'Product saved.',
    'admin.product.delete': 'Delete product',
    'admin.product.confirmDelete': 'Confirm product deletion',
    'admin.product.deleted': 'Product deleted.',
    'admin.product.invalidPrice': 'Amount in dinars with up to 3 decimals, for example 25.500.',
    'admin.product.error.version-conflict': 'This product was changed meanwhile. Reload the page, then make your changes again.',
    'admin.product.error.handle-taken': 'This address is already used.',
    'admin.product.error.sku-taken': 'A SKU is already used by another product.',
    'admin.product.error.validation': 'Some fields are not valid. Check the form.',
    'admin.collection.new': 'New collection',
    'admin.collection.edit': 'Edit collection',
    'admin.collection.empty': 'No collections yet.',
    'admin.collection.productCount': '{count, plural, one {# product} other {# products}}',
    'admin.collection.products': 'Products in the collection',
    'admin.collection.noProducts': 'No products in this collection.',
    'admin.collection.findProducts': 'Search products to add',
    'admin.collection.addProduct': 'Add {name}',
    'admin.collection.removeProduct': 'Remove {name}',
    'admin.collection.status.draft': 'Draft',
    'admin.collection.status.active': 'Visible',
    'admin.collection.save': 'Save collection',
    'admin.collection.saved': 'Collection saved.',
    'admin.collection.delete': 'Delete collection',
    'admin.collection.confirmDelete': 'Confirm collection deletion',
    'admin.collection.deleted': 'Collection deleted.',
    'admin.catalog.csv': 'Import and export',
    'admin.inventory.title': 'Stock',
    'admin.inventory.search': 'Search (name or SKU)',
    'admin.inventory.filter': 'Show',
    'admin.inventory.filter.all': 'All items',
    'admin.inventory.filter.tracked': 'Tracked stock',
    'admin.inventory.filter.out-of-stock': 'Out of stock',
    'admin.inventory.empty': 'No items.',
    'admin.inventory.column.item': 'Item',
    'admin.inventory.column.onHand': 'On hand',
    'admin.inventory.column.reserved': 'Reserved',
    'admin.inventory.column.available': 'Available',
    'admin.inventory.column.state': 'State',
    'admin.inventory.state.untracked': 'Not tracked (unlimited)',
    'admin.inventory.state.backorder': 'Sold when out of stock',
    'admin.inventory.state.out': 'Out of stock',
    'admin.inventory.state.in': 'Available',
    'admin.inventory.manage': 'Manage stock of {name}',
    'admin.inventory.settings': 'Stock tracking',
    'admin.inventory.track': 'Track stock for this item',
    'admin.inventory.allowBackorder': 'Keep selling when out of stock',
    'admin.inventory.saveSettings': 'Save settings',
    'admin.inventory.settingsSaved': 'Settings saved.',
    'admin.inventory.adjust': 'Adjust stock',
    'admin.inventory.reason': 'Reason',
    'admin.inventory.reason.received': 'Received',
    'admin.inventory.reason.returned': 'Customer return',
    'admin.inventory.reason.damaged': 'Damaged or lost',
    'admin.inventory.reason.correction': 'Correction',
    'admin.inventory.reason.count': 'Stock count',
    'admin.inventory.reason.reserved': 'Reserved',
    'admin.inventory.reason.released': 'Released',
    'admin.inventory.reason.expired': 'Reservation expired',
    'admin.inventory.reason.committed': 'Sold',
    'admin.inventory.reason.tracking': 'Tracking settings',
    'admin.inventory.quantity': 'Quantity',
    'admin.inventory.quantityHint': 'Number of units added or removed.',
    'admin.inventory.correctionHint': 'A negative number removes stock.',
    'admin.inventory.note': 'Note (optional)',
    'admin.inventory.apply': 'Save adjustment',
    'admin.inventory.count': 'Physical count',
    'admin.inventory.counted': 'Counted quantity',
    'admin.inventory.saveCount': 'Save count',
    'admin.inventory.saved': 'Stock updated.',
    'admin.inventory.history': 'History',
    'admin.inventory.noHistory': 'No movements yet.',
    'admin.inventory.column.date': 'Date',
    'admin.inventory.column.change': 'Change',
    'admin.inventory.column.after': 'Stock after',
    'admin.inventory.column.note': 'Note',
    'admin.inventory.error.stock-conflict': 'Stock cannot go below zero or below reserved quantities.',
    'admin.inventory.error.quantity': 'Enter a whole number.',
    'storefront.skipToContent': 'Skip to content',
    'storefront.menu': 'Main menu',
    'storefront.language': 'Language',
    'storefront.search': 'Search',
    'storefront.searchLabel': 'Search for a product',
    'storefront.searchTitle': 'Search',
    'storefront.results': '{count, plural, =0 {No results} one {# result} other {# results}} for “{query}”',
    'storefront.noResults': 'No products match your search.',
    'storefront.searchUnavailable': 'Search is unavailable right now. Try again in a moment.',
    'storefront.sort': 'Sort by',
    'storefront.sort.relevance': 'Relevance',
    'storefront.sort.price-asc': 'Price, low to high',
    'storefront.sort.price-desc': 'Price, high to low',
    'storefront.sort.newest': 'Newest',
    'storefront.apply': 'Apply',
    'storefront.previous': 'Previous page',
    'storefront.next': 'Next page',
    'storefront.available': 'In stock',
    'storefront.soldOut': 'Sold out',
    'storefront.from': 'From {price}',
    'storefront.oldPrice': 'Was {price}',
    'storefront.viewAll': 'View all',
    'storefront.emptyCollection': 'No products yet.',
    'storefront.productImages': 'Images of {title}',
    'storefront.noCombination': 'This combination is not available.',
    'storefront.preview': 'Preview: this version of the store is not published yet.',
    'storefront.notFound': 'Page not found',
    'storefront.notFoundText': 'The page you are looking for does not exist or is no longer available.',
    'storefront.backHome': 'Back to the home page',
    'storefront.storeNotFound': 'This store does not exist.',
    'storefront.storeUnavailable': 'This store is temporarily unavailable.',
    'storefront.error': 'Something went wrong.',
    'storefront.retry': 'Try again',
    'storefront.poweredBy': 'Store built with {brand}',
    'admin.theme.title': 'Store design',
    'admin.theme.colors': 'Colours and identity',
    'admin.theme.color.background': 'Background',
    'admin.theme.color.text': 'Text',
    'admin.theme.color.accent': 'Buttons and links',
    'admin.theme.color.accentText': 'Button text',
    'admin.theme.contrastLow': 'Contrast too low ({ratio}:1, minimum 4.5:1): text would be hard to read.',
    'admin.theme.logo': 'Logo',
    'admin.theme.noImage': 'No image',
    'admin.theme.announcementIn': 'Announcement bar ({language})',
    'admin.theme.navigation': 'Menu',
    'admin.theme.addNavItem': 'Add a menu link',
    'admin.theme.navLabelIn': 'Label of link {number} ({language})',
    'admin.theme.linkFor': 'Destination of link {number}',
    'admin.theme.removeNav': 'Remove link {number}',
    'admin.theme.link.none': 'None',
    'admin.theme.link.home': 'Home',
    'admin.theme.link.search': 'Search',
    'admin.theme.link.collection': 'Collection: {name}',
    'admin.theme.link.product': 'Product: {name}',
    'admin.theme.sections': 'Home page',
    'admin.theme.sectionType': 'Section type',
    'admin.theme.addSection': 'Add the section',
    'admin.theme.section.hero': 'Banner',
    'admin.theme.section.featured-collection': 'Featured collection',
    'admin.theme.section.product-grid': 'Latest products',
    'admin.theme.section.rich-text': 'Text',
    'admin.theme.section.image-with-text': 'Image with text',
    'admin.theme.sectionN': 'Section {number}: {type}',
    'admin.theme.headingIn': 'Heading ({language})',
    'admin.theme.textIn': 'Text ({language})',
    'admin.theme.buttonLabelIn': 'Button text ({language})',
    'admin.theme.buttonLink': 'Button destination',
    'admin.theme.image': 'Image',
    'admin.theme.imagePosition': 'Image position',
    'admin.theme.imagePosition.start': 'Before the text',
    'admin.theme.imagePosition.end': 'After the text',
    'admin.theme.collection': 'Collection',
    'admin.theme.limit': 'Number of products',
    'admin.theme.moveUp': 'Move section {number} up',
    'admin.theme.moveDown': 'Move section {number} down',
    'admin.theme.remove': 'Remove section {number}',
    'admin.theme.save': 'Save draft',
    'admin.theme.saved': 'Draft saved.',
    'admin.theme.preview': 'Preview',
    'admin.theme.openPreview': 'Open the preview',
    'admin.theme.previewHint': 'The preview link is valid for one hour.',
    'admin.theme.publish': 'Publish',
    'admin.theme.published': 'Published: your customers now see this version.',
    'admin.theme.unpublished': 'Some changes are not published yet.',
    'admin.theme.upToDate': 'The store shows the latest published version.',
    'admin.theme.history': 'Published versions',
    'admin.theme.noHistory': 'Nothing published yet.',
    'admin.theme.version': 'Version {number}',
    'admin.theme.current': 'Live',
    'admin.theme.restore': 'Restore version {number}',
    'admin.theme.restored': 'Version restored into the draft. Publish it to make it live.',
    'admin.theme.error.version-conflict': 'The design was changed meanwhile. Reload the page.',
    'admin.theme.template': 'Template',
    'admin.theme.template.souk': 'Souk',
    'admin.theme.template.atelier': 'Atelier',
    'admin.theme.template.ledger': 'Ledger',
    'admin.theme.template.hint': 'Applying a template replaces the draft colours and home page. The logo, menu and pages stay. Customers see it after you publish.',
    'admin.theme.template.apply': 'Apply {name}',
    'admin.theme.template.confirm': 'Replace the draft colours and home page with this template? The live site changes only when you publish.',
    'admin.theme.template.applied': 'Template applied to the draft. Publish it to show it to customers.',
    'admin.theme.link.page': 'Page: {name}',
    'admin.theme.pages': 'Pages',
    'admin.theme.addPage': 'Add a page',
    'admin.theme.pageHandle': 'Address of page {number}',
    'admin.theme.pageTitleIn': 'Title of page {number} ({language})',
    'admin.theme.removePage': 'Remove page {number}',
    'admin.theme.pageSectionType': 'Section type of page {number}',
    'admin.theme.addPageSection': 'Add a section to page {number}',
    'admin.theme.slots.product': 'Product page',
    'admin.theme.slots.collection': 'Collection page',
    'admin.theme.slots.cart': 'Cart',
    'admin.theme.slots.before': 'Before the content',
    'admin.theme.slots.after': 'After the content',
    'admin.theme.slotSectionType': 'Section type ({place})',
    'admin.theme.addSlotSection': 'Add a section ({place})',
    'admin.theme.place.product.before': 'before the product',
    'admin.theme.place.product.after': 'after the product',
    'admin.theme.place.collection.before': 'before the collection',
    'admin.theme.place.collection.after': 'after the collection',
    'admin.theme.place.cart.before': 'before the cart',
    'admin.theme.place.cart.after': 'after the cart',
    'admin.theme.reservedHandle': 'That address is already used by the shop (cart, checkout, search…).',
    'admin.theme.duplicateHandle': 'Two pages cannot share the same address.',
    // --- module 10: checkout settings, discount codes, orders ---
    'admin.checkout.title': 'Payments and delivery',
    'admin.checkout.unavailable': 'The store does not take orders yet: enable at least one payment method and one delivery method.',
    'admin.checkout.available': 'The store takes orders.',
    'admin.checkout.saved': 'Settings saved.',
    'admin.checkout.error.validation': 'Check the highlighted fields.',
    'admin.checkout.error.version-conflict': 'The settings were changed in the meantime. Reload the page.',
    'admin.checkout.payments': 'Payment methods',
    'admin.checkout.cashOnDelivery': 'Cash on delivery',
    'admin.checkout.bankTransfer': 'Bank transfer (you confirm receipt)',
    'admin.checkout.bankInstructionsIn': 'Transfer instructions ({language})',
    'admin.checkout.bankInstructionsHint': 'Bank details and account holder: shown to the customer and in the confirmation email.',
    'admin.checkout.delivery': 'Delivery',
    'admin.checkout.shippingEnabled': 'Home delivery',
    'admin.checkout.zone': 'Zone {number}',
    'admin.checkout.zoneNameIn': 'Zone name ({language})',
    'admin.checkout.zonePrice': 'Delivery fee (TND)',
    'admin.checkout.zoneFreeOver': 'Free delivery from (TND, optional)',
    'admin.checkout.zoneGovernorates': 'Governorates served',
    'admin.checkout.addZone': 'Add a zone',
    'admin.checkout.removeZone': 'Remove zone {number}',
    'admin.checkout.pickupEnabled': 'Store pickup',
    'admin.checkout.pickupAddressIn': 'Pickup address ({language})',
    'admin.checkout.taxes': 'Taxes',
    'admin.checkout.taxesEnabled': 'Compute VAT (VAT-registered business)',
    'admin.checkout.taxesHint': 'The rates are yours: check them with your accountant. beinstore applies no rate by default.',
    'admin.checkout.pricesIncludeTax': 'Store prices',
    'admin.checkout.pricesIncludeTax.yes': 'include VAT',
    'admin.checkout.pricesIncludeTax.no': 'exclude VAT (VAT added at checkout)',
    'admin.checkout.fiscalId': 'Tax ID (matricule fiscal)',
    'admin.checkout.taxClass': 'Rate {number}',
    'admin.checkout.taxClassKey': 'Code (used by products and the CSV)',
    'admin.checkout.taxClassNameIn': 'Name ({language})',
    'admin.checkout.taxClassRate': 'Rate (%)',
    'admin.checkout.addTaxClass': 'Add a rate',
    'admin.checkout.removeTaxClass': 'Remove rate {number}',
    'admin.checkout.defaultClass': 'Rate for products without one',
    'admin.checkout.shippingClass': 'Rate applied to delivery',
    'admin.checkout.noClass': 'None (untaxed)',
    'admin.checkout.fee': 'Fixed fee per order',
    'admin.checkout.feeAmount': 'Amount (TND, empty = none)',
    'admin.checkout.feeLabelIn': 'Label ({language})',
    'admin.checkout.feeHint': 'For example a fiscal stamp, if you apply one.',
    'admin.checkout.invalidAmount': 'Invalid amount.',
    'admin.checkout.invalidRate': 'Invalid rate (0 to 100, at most two decimals).',
    'admin.checkout.invalidKey': 'Lower-case letters, digits and hyphens.',
    'admin.discount.title': 'Discount codes',
    'admin.discount.new': 'New code',
    'admin.discount.empty': 'No discount codes yet.',
    'admin.discount.column.code': 'Code',
    'admin.discount.column.value': 'Discount',
    'admin.discount.column.used': 'Uses',
    'admin.discount.column.status': 'Status',
    'admin.discount.column.validity': 'Validity',
    'admin.discount.kind': 'Discount type',
    'admin.discount.kind.percentage': 'Percentage',
    'admin.discount.kind.fixed_amount': 'Fixed amount',
    'admin.discount.kind.free_shipping': 'Free delivery',
    'admin.discount.value.percentage': '{percent}%',
    'admin.discount.code': 'Code',
    'admin.discount.codeHint': 'Letters, digits, - and _ (3 to 40). Customers may type it in lower case.',
    'admin.discount.percent': 'Percentage (%)',
    'admin.discount.amount': 'Amount (TND)',
    'admin.discount.minSubtotal': 'Minimum cart amount (TND, optional)',
    'admin.discount.startsOn': 'Valid from (optional)',
    'admin.discount.endsOn': 'Valid until, inclusive (optional)',
    'admin.discount.datesHint': 'Dates in Tunis time.',
    'admin.discount.usageLimit': 'Total number of uses (optional)',
    'admin.discount.perCustomerLimit': 'Uses per customer (optional)',
    'admin.discount.perCustomerHint': 'A customer is recognised by their phone number.',
    'admin.discount.status': 'Status',
    'admin.discount.status.active': 'Active',
    'admin.discount.status.disabled': 'Disabled',
    'admin.discount.always': 'No date limit',
    'admin.discount.from': 'From {date}',
    'admin.discount.until': 'Until {date}',
    'admin.discount.between': 'From {start} to {end}',
    'admin.discount.edit': 'Edit code',
    'admin.discount.saved': 'Code saved.',
    'admin.discount.error.conflict': 'This code already exists.',
    'admin.discount.error.version-conflict': 'The code was changed in the meantime. Reload the page.',
    'admin.discount.error.validation': 'Check the highlighted fields.',
    'admin.discount.invalidPercent': 'Between 0.01 and 100.',
    'admin.discount.invalidNumber': 'Positive whole number.',
    'admin.discount.invalidDates': 'The end must be after the start.',
    'admin.order.title': 'Orders',
    'admin.order.search': 'Search (name, phone or number)',
    'admin.order.empty': 'No orders yet.',
    'admin.order.column.number': 'No.',
    'admin.order.column.date': 'Date',
    'admin.order.column.customer': 'Customer',
    'admin.order.column.total': 'Total',
    'admin.order.column.payment': 'Payment',
    'admin.order.column.delivery': 'Delivery',
    'admin.order.number': 'Order #{number}',
    'admin.order.open': 'Open order #{number}',
    'admin.order.payment.cash_on_delivery': 'Cash on delivery',
    'admin.order.payment.bank_transfer': 'Bank transfer',
    'admin.order.paymentStatus': 'Payment status',
    'admin.order.paymentStatus.pending': 'Pending',
    'admin.order.paymentStatus.paid': 'Paid',
    'admin.order.delivery.shipping': 'Home delivery',
    'admin.order.delivery.pickup': 'Store pickup',
    'admin.order.placedAt': 'Placed on {date}',
    'admin.order.customer': 'Customer',
    'admin.order.phone': 'Phone',
    'admin.order.email': 'Email',
    'admin.order.address': 'Delivery address',
    'admin.order.note': 'Customer note',
    'admin.order.items': 'Items',
    'admin.order.column.item': 'Item',
    'admin.order.column.unitPrice': 'Unit price',
    'admin.order.column.quantity': 'Quantity',
    'admin.order.subtotal': 'Subtotal',
    'admin.order.discount': 'Discount ({code})',
    'admin.order.shipping': 'Delivery',
    'admin.order.tax': 'VAT',
    'admin.order.taxIncluded': 'including VAT',
    'admin.order.taxLine': 'VAT {rate}% on {net}: {tax}',
    'admin.order.fee': 'Fee ({label})',
    'admin.order.total': 'Total',
    'admin.order.instructions': 'Instructions sent to the customer',
    'admin.order.fiscalNote': 'Amounts recorded when the order was placed; they no longer change.',
    'admin.product.taxClass': 'VAT rate',
    'admin.product.taxClass.default': 'Store default rate',
    'admin.product.taxClass.unknown': '{key} (not in the settings: default rate applied)',
    // --- module 10: storefront cart and checkout ---
    'storefront.cart': 'Cart',
    'storefront.cartWithCount': 'Cart ({count, plural, =0 {empty} one {# item} other {# items}})',
    'storefront.cart.title': 'Your cart',
    'storefront.cart.empty': 'Your cart is empty.',
    'storefront.cart.continue': 'Continue shopping',
    'storefront.cart.product': 'Item',
    'storefront.cart.price': 'Price',
    'storefront.cart.quantity': 'Quantity',
    'storefront.cart.quantityOf': 'Quantity of {title}',
    'storefront.cart.lineTotal': 'Total',
    'storefront.cart.update': 'Update',
    'storefront.cart.remove': 'Remove',
    'storefront.cart.removeItem': 'Remove {title} from the cart',
    'storefront.cart.unavailable': 'No longer available: remove it to order.',
    'storefront.cart.subtotal': 'Subtotal',
    'storefront.cart.discount': 'Discount ({code})',
    'storefront.cart.shipping': 'Delivery',
    'storefront.cart.shippingLater': 'Calculated at the next step',
    'storefront.cart.free': 'Free',
    'storefront.cart.tax': 'VAT',
    'storefront.cart.taxIncluded': 'including VAT',
    'storefront.cart.fee': 'Fee',
    'storefront.cart.total': 'Total',
    'storefront.cart.checkout': 'Check out',
    'storefront.cart.checkoutUnavailable': 'This store does not take online orders yet.',
    'storefront.cart.add': 'Add to cart',
    'storefront.cart.error.sold-out': 'This product is sold out.',
    'storefront.cart.error.full': 'Your cart is full.',
    'storefront.cart.error.unavailable': 'This product is no longer available.',
    'storefront.cart.error.too-many': 'Too many attempts. Try again in a few minutes.',
    'storefront.cart.error.generic': 'Something went wrong. Try again.',
    'storefront.discount.label': 'Discount code',
    'storefront.discount.apply': 'Apply',
    'storefront.discount.remove': 'Remove the code',
    'storefront.discount.applied': 'Discount code applied.',
    'storefront.discount.refusal.unknown': 'This code does not exist.',
    'storefront.discount.refusal.inactive': 'This code is no longer active.',
    'storefront.discount.refusal.not-started': 'This code is not valid yet.',
    'storefront.discount.refusal.expired': 'This code has expired.',
    'storefront.discount.refusal.minimum': 'Your cart amount is too low for this code.',
    'storefront.discount.refusal.exhausted': 'This code has reached its usage limit.',
    'storefront.discount.refusal.customer-limit': 'You have already used this code.',
    'storefront.discount.refusal.too-many': 'Too many tries. Try again later.',
    'storefront.discount.refusal.error': 'The code could not be checked. Try again.',
    'storefront.checkout.title': 'Checkout',
    'storefront.checkout.backToCart': 'Back to cart',
    'storefront.checkout.deliveryChoice': 'Delivery method',
    'storefront.checkout.pickup': 'Store pickup',
    'storefront.checkout.pickupAt': 'Store pickup: {address}',
    'storefront.checkout.shippingTo': 'Home delivery',
    'storefront.checkout.governorate': 'Governorate',
    'storefront.checkout.choose': 'Choose…',
    'storefront.checkout.governoratePrice': '{name} — {price}',
    'storefront.checkout.governoratePriceFree': '{name} — {price}, free from {amount}',
    'storefront.checkout.continue': 'Continue',
    'storefront.checkout.change': 'Change delivery',
    'storefront.checkout.notServed': 'The store does not deliver to this governorate.',
    'storefront.checkout.contact': 'Your details',
    'storefront.checkout.name': 'Full name',
    'storefront.checkout.phone': 'Phone',
    'storefront.checkout.phoneHint': 'Tunisian 8-digit number, or international with +',
    'storefront.checkout.email': 'Email (optional, to receive the confirmation)',
    'storefront.checkout.address': 'Delivery address',
    'storefront.checkout.city': 'City',
    'storefront.checkout.line1': 'Address (street, number)',
    'storefront.checkout.line2': 'Address details (optional)',
    'storefront.checkout.postalCode': 'Postal code (optional)',
    'storefront.checkout.payment': 'Payment',
    'storefront.checkout.cashOnDelivery': 'Cash on delivery',
    'storefront.checkout.bankTransfer': 'Bank transfer',
    'storefront.checkout.note': 'Note for the store (optional)',
    'storefront.checkout.place': 'Place order ({total})',
    'storefront.checkout.summary': 'Summary',
    'storefront.checkout.field.required': 'This field is required.',
    'storefront.checkout.field.phone': 'Invalid phone number.',
    'storefront.checkout.field.email': 'Invalid email address.',
    'storefront.checkout.field.postalCode': 'Four digits.',
    'storefront.checkout.field.invalid': 'Invalid value.',
    'storefront.checkout.error.validation': 'Check the information you entered.',
    'storefront.checkout.error.cart-changed': 'Some items are no longer available. Check your cart.',
    'storefront.checkout.error.discount-invalid': 'The discount code can no longer be used. Remove it from your cart.',
    'storefront.checkout.error.checkout-unavailable': 'The store no longer offers this choice.',
    'storefront.checkout.error.insufficient-stock': 'An item is no longer available in that quantity.',
    'storefront.checkout.error.too-many-requests': 'Too many attempts. Try again in a few minutes.',
    'storefront.checkout.error.generic': 'The order could not be placed. Try again.',
    'storefront.order.title': 'Thank you for your order!',
    'storefront.order.number': 'Order #{number}',
    'storefront.order.cashOnDelivery': 'You will pay on delivery: please have {total} ready.',
    'storefront.order.bankTransfer': 'Please transfer {total}:',
    'storefront.order.pickup': 'Store pickup: the store will contact you when your order is ready.',
    'storefront.order.shippingTo': 'Delivery to:',
    'storefront.order.contact': 'The store will contact you at {phone}.',
    'storefront.order.keep': 'Keep this page’s address: it lets you see your order again.',
    'storefront.order.view': 'View my order',
    'storefront.order.notFound': 'Order not found.',
    // --- module 11: order management, invoices ---
    'email.orderStatus.confirmed.subject': 'Order #{number} confirmed by {store}',
    'email.orderStatus.confirmed.heading': 'Your order is confirmed',
    'email.orderStatus.confirmed.intro': '{store} has confirmed your order #{number} and is preparing it.',
    'email.orderStatus.shipped.subject': 'Order #{number} shipped – {store}',
    'email.orderStatus.shipped.heading': 'Your order is on its way',
    'email.orderStatus.shipped.intro': '{store} has shipped your order #{number}.',
    'email.orderStatus.delivered.subject': 'Order #{number} delivered – {store}',
    'email.orderStatus.delivered.heading': 'Your order was delivered',
    'email.orderStatus.delivered.intro': 'Your order #{number} from {store} was delivered. Thank you!',
    'email.orderStatus.cancelled.subject': 'Order #{number} cancelled – {store}',
    'email.orderStatus.cancelled.heading': 'Your order was cancelled',
    'email.orderStatus.cancelled.intro': '{store} cancelled your order #{number}. Contact the store with any question.',
    'email.orderStatus.tracking': 'Tracking: {note}',
    'invoice.title': 'Invoice',
    'invoice.number': 'No. {number}',
    'invoice.date': 'Date: {date}',
    'invoice.order': 'Order #{number} of {date}',
    'invoice.taxId': 'Tax ID: {taxId}',
    'invoice.billTo': 'Customer',
    'invoice.payment': 'Payment and delivery',
    'invoice.paymentMethod.cash_on_delivery': 'Cash on delivery',
    'invoice.paymentMethod.bank_transfer': 'Bank transfer',
    'invoice.delivery.shipping': 'Home delivery',
    'invoice.delivery.pickup': 'Store pickup',
    'invoice.column.item': 'Item',
    'invoice.column.quantity': 'Qty',
    'invoice.column.unitPrice': 'Unit price',
    'invoice.column.discount': 'Discount',
    'invoice.column.total': 'Amount',
    'invoice.subtotal': 'Subtotal',
    'invoice.discount': 'Discount',
    'invoice.discountCode': 'Discount ({code})',
    'invoice.shipping': 'Delivery',
    'invoice.fee': 'Fee',
    'invoice.tax': 'VAT',
    'invoice.taxIncluded': 'including VAT',
    'invoice.taxLine': 'VAT {rate}% on {net}: {tax}',
    'invoice.total': 'Total',
    'admin.inventory.reason.cancelled': 'Order cancelled',
    'admin.order.status': 'Status',
    'admin.order.status.placed': 'New',
    'admin.order.status.confirmed': 'Confirmed',
    'admin.order.status.shipped': 'Shipped',
    'admin.order.status.delivered': 'Delivered',
    'admin.order.status.cancelled': 'Cancelled',
    'admin.order.status.returned': 'Returned',
    'admin.order.paymentStatus.refunded': 'Refunded',
    'admin.order.filter.allStatuses': 'All statuses',
    'admin.order.filter.allPayments': 'All payments',
    'admin.order.actions': 'Actions',
    'admin.order.noActions': 'No action available: the order is closed.',
    'admin.order.action.confirm': 'Confirm the order',
    'admin.order.action.ship': 'Mark as shipped',
    'admin.order.action.deliver': 'Mark as delivered',
    'admin.order.action.cancel': 'Cancel the order',
    'admin.order.action.return': 'Record a return',
    'admin.order.action.mark-paid': 'Mark as paid',
    'admin.order.action.refund': 'Mark as refunded',
    'admin.order.trackingNote': 'Tracking for the customer (optional)',
    'admin.order.trackingNoteHint': 'Carrier, tracking number… emailed to the customer.',
    'admin.order.actionNote': 'Internal note (optional)',
    'admin.order.cancelHint': 'Tracked items go back on sale.',
    'admin.order.returnHint': 'Enter what goes back to stock; damaged items stay out.',
    'admin.order.restockOf': 'Back to stock: {title}',
    'admin.order.apply': 'Apply',
    'admin.order.updated': 'Order updated.',
    'admin.order.error.invalid-transition': 'This change is no longer possible. Reload the page.',
    'admin.order.error.version-conflict': 'The order was changed in the meantime. Reload the page.',
    'admin.order.error.invoice-settings-missing': 'First enter the legal name and address in the invoicing settings.',
    'admin.order.error.invoice-exists': 'The invoice already exists.',
    'admin.order.tracking': 'Tracking: {note}',
    'admin.order.history': 'History',
    'admin.order.history.placed': 'Order placed',
    'admin.order.history.status': 'Status: {from} → {to}',
    'admin.order.history.payment': 'Payment: {from} → {to}',
    'admin.order.history.note': 'Note',
    'admin.order.history.invoice': 'Invoice {number} issued',
    'admin.order.history.restocked': '{count, plural, one {# item back to stock} other {# items back to stock}}',
    'admin.order.noteLabel': 'Internal note',
    'admin.order.addNote': 'Add the note',
    'admin.order.noteAdded': 'Note added.',
    'admin.order.invoice': 'Invoice',
    'admin.order.invoiceNone': 'No invoice issued.',
    'admin.order.invoiceLanguage': 'Invoice language',
    'admin.order.issueInvoice': 'Issue the invoice',
    'admin.order.invoiceIssued': 'Invoice issued.',
    'admin.order.downloadInvoice': 'Download invoice {number} (PDF)',
    'admin.invoice.title': 'Invoicing',
    'admin.invoice.intro': 'This information is printed as is on your invoices. You are responsible for its accuracy and for any mandatory mentions; beinstore adds no legal wording.',
    'admin.invoice.legalNameIn': 'Legal name ({language})',
    'admin.invoice.addressIn': 'Address ({language})',
    'admin.invoice.taxId': 'Tax ID (optional)',
    'admin.invoice.footerIn': 'Footer text ({language}, optional)',
    'admin.invoice.prefix': 'Number prefix (optional)',
    'admin.invoice.prefixHint': 'Letters, digits, / and - (12 at most), e.g. INV-. Numbers follow each other without gaps.',
    'admin.invoice.invalidPrefix': 'Invalid prefix.',
    'admin.invoice.saved': 'Invoicing settings saved.',
    'admin.invoice.error.validation': 'Check the highlighted fields.',
    'admin.invoice.error.version-conflict': 'The settings were changed in the meantime. Reload the page.',
    'storefront.order.status': 'Status: {status}',
    'storefront.order.status.placed': 'Received, awaiting confirmation',
    'storefront.order.status.confirmed': 'Confirmed, being prepared',
    'storefront.order.status.shipped': 'Shipped',
    'storefront.order.status.delivered': 'Delivered',
    'storefront.order.status.cancelled': 'Cancelled',
    'storefront.order.status.returned': 'Returned',
    'storefront.order.tracking': 'Tracking: {note}',
    // --- module 16: private apps and webhooks ---
    'admin.integrations.title': 'Apps and webhooks',
    'admin.integrations.intro': 'Connect your own tools (ERP, point of sale, spreadsheet) to your store.',
    'admin.integrations.apps': 'Private apps',
    'admin.integrations.appsIntro': 'Each app gets a secret token limited to the permissions you choose. Only give it to someone you trust.',
    'admin.integrations.appName': 'App name',
    'admin.integrations.scopes': 'Permissions',
    'admin.integrations.scope.products.read': 'Read products',
    'admin.integrations.scope.inventory.read': 'Read stock',
    'admin.integrations.scope.inventory.write': 'Update stock',
    'admin.integrations.scope.orders.read': 'Read orders (including customer details)',
    'admin.integrations.scope.orders.write': 'Process orders (confirm, ship, deliver, cancel)',
    'admin.integrations.createApp': 'Create the app',
    'admin.integrations.tokenTitle': 'Token of “{name}”',
    'admin.integrations.tokenWarning': 'Copy this token now: it will not be shown again. Send it in the Authorization: Bearer header.',
    'admin.integrations.noApps': 'No apps.',
    'admin.integrations.column.name': 'Name',
    'admin.integrations.column.scopes': 'Permissions',
    'admin.integrations.column.token': 'Token',
    'admin.integrations.column.lastUsed': 'Last used',
    'admin.integrations.column.status': 'Status',
    'admin.integrations.column.result': 'Result',
    'admin.integrations.never': 'Never',
    'admin.integrations.appStatus.active': 'Active',
    'admin.integrations.appStatus.revoked': 'Revoked',
    'admin.integrations.revoke': 'Revoke {name}',
    'admin.integrations.revoked': 'App revoked: its token no longer works.',
    'admin.integrations.webhooks': 'Webhooks',
    'admin.integrations.webhooksIntro': 'beinstore sends a signed POST request to your address for each chosen event. Check the signature with the address secret.',
    'admin.integrations.webhooksDisabled': 'Webhooks are not configured on the platform yet.',
    'admin.integrations.url': 'Receiving address (https)',
    'admin.integrations.events': 'Events',
    'admin.integrations.event.order.placed': 'Order placed',
    'admin.integrations.event.order.status_changed': 'Order status changed',
    'admin.integrations.event.order.payment_changed': 'Order payment changed',
    'admin.integrations.event.product.created': 'Product created',
    'admin.integrations.event.product.updated': 'Product updated',
    'admin.integrations.event.product.deleted': 'Product deleted',
    'admin.integrations.event.inventory.availability_changed': 'Availability changed',
    'admin.integrations.event.invoice.issued': 'Invoice issued',
    'admin.integrations.addEndpoint': 'Add the address',
    'admin.integrations.noEndpoints': 'No addresses.',
    'admin.integrations.endpointStatus.active': 'Active',
    'admin.integrations.endpointStatus.disabled': 'Disabled',
    'admin.integrations.disabledByFailures': 'Disabled after repeated failures',
    'admin.integrations.secret': 'Signing secret',
    'admin.integrations.showSecret': 'Show the secret',
    'admin.integrations.rotateSecret': 'Change the secret',
    'admin.integrations.rotated': 'New secret: the previous one no longer works.',
    'admin.integrations.ping': 'Send a test',
    'admin.integrations.pinged': 'Test queued.',
    'admin.integrations.disable': 'Disable',
    'admin.integrations.enable': 'Enable again',
    'admin.integrations.delete': 'Delete',
    'admin.integrations.deliveries': 'Show deliveries',
    'admin.integrations.noDeliveries': 'No deliveries.',
    'admin.integrations.delivery.pending': 'Pending',
    'admin.integrations.delivery.succeeded': 'Succeeded',
    'admin.integrations.delivery.failed': 'Failed',
    'admin.integrations.attempts': '{count, plural, one {# attempt} other {# attempts}}',
    'admin.integrations.redeliver': 'Send again',
    'admin.integrations.redelivered': 'Delivery queued again.',
    'admin.integrations.error.app': 'Enter a name and at least one permission.',
    'admin.integrations.error.endpoint': 'Enter an address and at least one event.',
    'admin.integrations.error.url-scheme': 'Use an https address.',
    'admin.integrations.error.url-credentials': 'The address must not contain credentials.',
    'admin.integrations.error.url-address': 'This address is not allowed (private or local network).',
    'admin.integrations.error.url-invalid': 'Invalid address.',
    'admin.integrations.error.limit': 'Limit reached: delete or revoke one first.',
    'admin.integrations.error.version-conflict': 'The address was changed in the meantime. Reload the page.',
    // --- module 17: analytics, customer data ---
    'admin.analytics.title': 'Analytics',
    'admin.analytics.definition': 'Sales = orders neither cancelled nor returned (full amount, including delivery and fees). Dates in Tunis time.',
    'admin.analytics.from': 'From',
    'admin.analytics.to': 'To',
    'admin.analytics.granularity': 'Group by',
    'admin.analytics.granularity.day': 'Day',
    'admin.analytics.granularity.week': 'Week',
    'admin.analytics.granularity.month': 'Month',
    'admin.analytics.exportOrders': 'Export the orders of the period (CSV)',
    'admin.analytics.revenue': 'Sales',
    'admin.analytics.orders': 'Orders',
    'admin.analytics.averageBasket': 'Average basket',
    'admin.analytics.change': '{percent}% versus the previous period',
    'admin.analytics.noComparison': 'No previous period to compare',
    'admin.analytics.sales': 'Sales per period',
    'admin.analytics.chartLabel': 'Sales from {from} to {to}: {total}',
    'admin.analytics.showTable': 'Show the figures',
    'admin.analytics.period': 'Period',
    'admin.analytics.topProducts': 'Best sellers',
    'admin.analytics.noSales': 'No sales in the period.',
    'admin.analytics.byGovernorate': 'Sales by governorate',
    'admin.analytics.region': 'Governorate',
    'admin.analytics.share': 'Share of orders',
    'admin.analytics.funnel': 'Order progress',
    'admin.analytics.payments': 'Collections',
    'admin.analytics.range': 'Period',
    'admin.analytics.preset.7d': 'Last 7 days',
    'admin.analytics.preset.30d': 'Last 30 days',
    'admin.analytics.preset.90d': 'Last 90 days',
    'admin.analytics.preset.month': 'This month',
    'admin.analytics.itemsSold': 'Items sold',
    'admin.analytics.cancelled': 'Cancellations',
    'admin.analytics.returned': 'Returns',
    'admin.analytics.outcomes': 'Orders, cancellations and returns',
    'admin.analytics.outcomesLabel': 'Orders, cancellations and returns from {from} to {to}',
    'admin.analytics.catalog': 'Catalog',
    'admin.analytics.overview': 'Store overview',
    'admin.analytics.seeDashboard': 'Open the dashboard',
    'admin.privacy.title': 'Customer data',
    'admin.privacy.intro': 'Answer your customers’ requests: find their orders, export their data or erase it. Erasure removes name, phone, email, address and note; amounts and issued invoices are kept.',
    'admin.privacy.identifier': 'Search by',
    'admin.privacy.search': 'Search',
    'admin.privacy.found': '{count, plural, =0 {No orders hold this customer’s data.} one {# order holds this customer’s data.} other {# orders hold this customer’s data.}}',
    'admin.privacy.export': 'Export the data (JSON)',
    'admin.privacy.exported': 'Data exported.',
    'admin.privacy.eraseHint': 'Orders must be delivered, cancelled or returned before erasure. This cannot be undone.',
    'admin.privacy.erase': 'Erase the data',
    'admin.privacy.confirm': 'I confirm the permanent erasure of this customer’s personal data',
    'admin.privacy.erased': '{count, plural, one {Data erased from # order.} other {Data erased from # orders.}}',
    'admin.privacy.log': 'Request history',
    'admin.privacy.noLog': 'No requests.',
    'admin.privacy.kind.export': 'Export',
    'admin.privacy.kind.erase': 'Erasure',
    'admin.privacy.kind.retention': 'Retention period',
    'admin.privacy.ordersAffected': '{count, plural, one {# order} other {# orders}}',
    'admin.privacy.error.inProgress': 'Some orders are still in progress. {detail}',
    'admin.privacy.error.identifier': 'Invalid number or email.',
    'admin.privacy.erasedCustomer': 'Erased customer',
    'admin.privacy.erasedOn': 'Customer data erased on {date}.',
    // --- module 14: cash-on-delivery management ---
    'email.order.respond': 'Confirm my order',
    'email.order.view': 'Follow my order',
    'email.order.respondHint': 'Please confirm your order so the store can prepare it.',
    'storefront.order.respondIntro': 'Cash on delivery: confirm your order so the store prepares it.',
    'storefront.order.confirm': 'I confirm my order',
    'storefront.order.cancel': 'Cancel my order',
    'storefront.order.confirmed': 'Thank you, your order is confirmed.',
    'storefront.order.cancelled': 'Your order is cancelled.',
    'storefront.order.actionFailed': 'This order can no longer be changed here.',
    'admin.cod.title': 'Cash on delivery',
    'admin.cod.intro': 'Order confirmation, automatic cancellation and refused numbers.',
    'admin.cod.customerConfirmation': 'The customer confirms the order from the order page and the email; they can cancel after confirmation',
    'admin.cod.autoCancelHours': 'Cancel unconfirmed orders after (hours)',
    'admin.cod.autoCancelHint': 'Leave empty to never cancel automatically. Stock is put back and the customer gets the cancellation email.',
    'admin.cod.refusalThreshold': 'Flag a number from this many returned orders',
    'admin.cod.refusalHint': 'Counted on your store’s orders only. Leave empty to flag nothing.',
    'admin.cod.saved': 'Settings saved.',
    'admin.cod.blocked.title': 'Numbers refused cash on delivery',
    'admin.cod.blocked.hint': 'These numbers can no longer choose cash on delivery in your store. Only the last digits are kept.',
    'admin.cod.blocked.none': 'No numbers.',
    'admin.cod.blocked.entry': 'Number ending in {hint}',
    'admin.cod.blocked.phone': 'Phone number',
    'admin.cod.blocked.reason': 'Reason (optional)',
    'admin.cod.blocked.add': 'Block this number',
    'admin.cod.blocked.remove': 'Unblock the number ending in {hint}',
    'admin.cod.panel': 'Cash-on-delivery follow-up',
    'admin.cod.firstOrder': 'First order from this number in your store.',
    'admin.cod.pastOrders': 'Other orders from this number: {delivered} delivered, {returned} returned, {cancelled} cancelled, {inProgress} in progress.',
    'admin.cod.warning': 'Warning: {returned, plural, one {# returned order} other {# returned orders}} for this number.',
    'admin.cod.isBlocked': 'This number is refused cash on delivery.',
    'admin.cod.calls': '{count, plural, =0 {No calls logged.} one {# call logged.} other {# calls logged.}}',
    'admin.cod.logCall': 'Log the call',
    'admin.cod.outcome': 'Call outcome',
    'admin.cod.outcome.confirmed': 'Confirmed by the customer',
    'admin.cod.outcome.declined': 'Declined by the customer',
    'admin.cod.outcome.no_answer': 'No answer',
    'admin.cod.outcome.unreachable': 'Unreachable or wrong number',
    'admin.cod.outcome.callback': 'Call back later',
    'admin.cod.outcomeHint': '“Confirmed” confirms the order; “Declined” cancels it and puts the stock back.',
    'admin.cod.callNote': 'Note (optional)',
    'admin.cod.callLogged': 'Call logged.',
    'admin.cod.block': 'Refuse cash on delivery to this number',
    'admin.cod.unblock': 'Accept this number again',
    'admin.cod.blockedDone': 'Number refused cash on delivery.',
    'admin.cod.unblockedDone': 'Number accepted again.',
    'admin.cod.error.phone': 'Invalid phone number.',
    'admin.cod.history.call': 'Call: {outcome}',
    'admin.order.history.byCustomer': 'by the customer',
    'admin.order.history.automatic': 'automatically',
    // --- module 13: shipping by settings ---
    'email.shipment.carrier': 'Carrier: {carrier}',
    'email.shipment.line': '{carrier} — tracking number: {tracking}',
    'email.shipment.ownDelivery': 'Delivered by the store',
    'email.shipment.track': 'Track my parcel',
    'email.shipment.subject': 'Another parcel of order #{number} is on its way – {store}',
    'email.shipment.heading': 'Another parcel is on its way',
    'email.shipment.intro': '{store} has shipped another part of your order #{number}.',
    'deliveryNote.title': 'Delivery note',
    'deliveryNote.reference': 'Reference: {reference}',
    'deliveryNote.date': 'Date: {date}',
    'deliveryNote.recipient': 'Recipient',
    'deliveryNote.carrier': 'Carrier',
    'deliveryNote.ownDelivery': 'Delivered by the store',
    'deliveryNote.tracking': 'Tracking number: {tracking}',
    'deliveryNote.collect': 'To collect on delivery: {amount}',
    'deliveryNote.nothingToCollect': 'Nothing to collect on delivery',
    'deliveryNote.column.item': 'Item',
    'deliveryNote.column.quantity': 'Quantity',
    'deliveryNote.customerNote': 'Customer note',
    'storefront.order.shipments': 'Parcels',
    'storefront.order.shipment': 'Parcel {number}',
    'storefront.order.shipment.shipped': 'on its way',
    'storefront.order.shipment.delivered': 'delivered',
    'storefront.order.shipment.returned': 'returned',
    'storefront.order.shipment.ownDelivery': 'Delivered by the store',
    'storefront.order.shipment.tracking': 'Tracking number: {tracking}',
    'storefront.order.shipment.track': 'Track parcel {number}',
    'admin.carriers.title': 'Carriers',
    'admin.carriers.intro': 'The carriers you work with. There is no connection to their systems: you enter the tracking number when shipping.',
    'admin.carriers.none': 'No carriers.',
    'admin.carriers.name': 'Name',
    'admin.carriers.phone': 'Phone (optional)',
    'admin.carriers.trackingUrl': 'Tracking address (optional)',
    'admin.carriers.trackingUrlHint': 'Starts with https:// and contains {placeholder}, replaced by the tracking number.',
    'admin.carriers.defaultFee': 'Usual fee per parcel (TND, optional)',
    'admin.carriers.active': 'Offer this carrier when shipping',
    'admin.carriers.add': 'Add the carrier',
    'admin.carriers.edit': 'Edit {name}',
    'admin.carriers.added': 'Carrier added.',
    'admin.carriers.saved': 'Carrier saved.',
    'admin.carriers.inactive': 'inactive',
    'admin.carriers.error.conflict': 'A carrier already has this name (or the limit is reached).',
    'admin.carriers.error.validation': 'Check the name, phone, tracking address and fee.',
    'admin.shipment.title': 'Parcels',
    'admin.shipment.none': 'No parcels sent.',
    'admin.shipment.number': 'Parcel {number}',
    'admin.shipment.ownDelivery': 'Delivered by the store',
    'admin.shipment.status.shipped': 'On its way',
    'admin.shipment.status.delivered': 'Delivered',
    'admin.shipment.status.returned': 'Returned',
    'admin.shipment.tracking': 'Tracking: {tracking}',
    'admin.shipment.cod': 'To collect: {amount}',
    'admin.shipment.fee': 'Carrier fee: {amount}',
    'admin.shipment.items': '{count, plural, one {# item} other {# items}}',
    'admin.shipment.markDelivered': 'Mark parcel {number} as delivered',
    'admin.shipment.markReturned': 'Mark parcel {number} as returned',
    'admin.shipment.note': 'Delivery note of parcel {number} ({language})',
    'admin.shipment.new': 'Ship a parcel',
    'admin.shipment.quantity': 'Quantity to ship: {item}',
    'admin.shipment.left': '{count} left',
    'admin.shipment.carrier': 'Carrier',
    'admin.shipment.trackingNumber': 'Tracking number (optional)',
    'admin.shipment.feeLabel': 'Carrier fee (TND, optional)',
    'admin.shipment.feeHint': 'Empty: the carrier’s usual fee.',
    'admin.shipment.codLabel': 'To collect on delivery (TND, optional)',
    'admin.shipment.codHint': 'Empty: everything still to collect.',
    'admin.shipment.create': 'Ship',
    'admin.shipment.created': 'Parcel recorded.',
    'admin.shipment.updated': 'Parcel updated.',
    'admin.shipment.error.validation': 'Check the quantities (no more than left to ship), the tracking number and the amounts (no more than left to collect).',
    'admin.shipment.error.empty': 'Choose at least one item.',
    'admin.order.history.shipment': 'Parcel {number}: {status}',
    // --- module 12: cash-on-delivery payments ---
    'admin.cash.title': 'Cash',
    'admin.cash.total': 'Order total: {amount}',
    'admin.cash.collected': 'Collected: {amount}',
    'admin.cash.refunded': 'Refunded: {amount}',
    'admin.cash.due': 'Still to collect: {amount}',
    'admin.cash.none': 'No cash recorded.',
    'admin.cash.kind.collection': 'Collection',
    'admin.cash.kind.refund': 'Refund',
    'admin.cash.kind.reversal': 'Reversal',
    'admin.cash.byCarrier': 'by {carrier}',
    'admin.cash.byMerchant': 'by the store',
    'admin.cash.parcel': 'parcel {number}',
    'admin.cash.automatic': 'automatic',
    'admin.cash.reversed': 'reversed',
    'admin.cash.remitted': 'handed over by the courier',
    'admin.cash.reverse': 'Reverse the entry of {date}',
    'admin.cash.reversedDone': 'Entry reversed.',
    'admin.cash.collect': 'Record a collection',
    'admin.cash.amount': 'Amount (TND)',
    'admin.cash.collector': 'Collected by',
    'admin.cash.merchant': 'The store',
    'admin.cash.note': 'Note (optional)',
    'admin.cash.collectedDone': 'Collection recorded.',
    'admin.cash.refund': 'Record a refund',
    'admin.cash.refundedDone': 'Refund recorded.',
    'admin.cash.error.amount': 'Invalid amount: no more than what is still to collect (or what was collected, for a refund).',
    'admin.cash.error.reverse': 'This entry cannot be reversed (already reversed, or the courier already handed the cash over: record a refund).',
    'admin.payments.title': 'Cash and couriers',
    'admin.payments.intro': 'Cash on delivery: the cash couriers collect is handed over to you, their fees deducted.',
    'admin.payments.inHand': 'In hand: {amount}',
    'admin.payments.withCarriers': 'With couriers: {amount}',
    'admin.payments.owed': '{name} owes you {amount} ({count, plural, one {# collection} other {# collections}})',
    'admin.payments.lastRemittance': 'Last handover: {date}',
    'admin.payments.remit': 'Record a handover from {name}',
    'admin.payments.order': 'Order #{number}',
    'admin.payments.fees': 'Fees kept by the courier (TND)',
    'admin.payments.feesHint': 'Suggested: the parcels’ fees ({amount}).',
    'admin.payments.receivedAt': 'Handover date',
    'admin.payments.net': 'Amount received: {amount}',
    'admin.payments.save': 'Record the handover',
    'admin.payments.saved': 'Handover recorded.',
    'admin.payments.history': 'Handovers',
    'admin.payments.remittance': '{date} — {name}: {net} received ({gross} collected, {fees} fees)',
    'admin.payments.none': 'No handovers.',
    'admin.payments.nothingOwed': 'Nothing pending with this courier.',
    'admin.payments.error.select': 'Choose at least one collection.',
    'admin.payments.error.stale': 'These collections are no longer pending: reload the page.',
    // --- module 15: billing, custom domains, operator console ---
    'platformInvoice.title': 'Invoice',
    'platformInvoice.taxId': 'Tax ID: {taxId}',
    'platformInvoice.number': 'No. {number}',
    'platformInvoice.date': 'Date: {date}',
    'platformInvoice.billTo': 'Billed to',
    'platformInvoice.column.description': 'Description',
    'platformInvoice.column.amount': 'Amount',
    'platformInvoice.line': 'Subscription {plan} — {months} months, from {from} to {to}',
    'platformInvoice.net': 'Total before VAT',
    'platformInvoice.vat': 'VAT {rate}%',
    'platformInvoice.total': 'Total',
    'platformInvoice.paid': 'Paid by {method} on {date}',
    'platformInvoice.method.bank_transfer': 'bank transfer',
    'platformInvoice.method.cash': 'cash',
    'platformInvoice.method.other': 'other means',
    'platformInvoice.reference': 'Reference: {reference}',
    'admin.error.subscription-restricted': 'Unpaid subscription: only orders can be changed until it is paid.',
    'admin.error.plan-limit-reached': 'Your plan’s limit is reached: upgrade the plan to add more.',
    'admin.billing.title': 'Subscription',
    'admin.billing.none': 'Your store has no plan yet.',
    'admin.billing.plan': 'Plan: {name}',
    'admin.billing.price': '{amount} every {months, plural, one {month} other {# months}}',
    'admin.billing.state.none': 'No subscription.',
    'admin.billing.state.free': 'Free plan.',
    'admin.billing.state.trialing': 'Free trial until {date}.',
    'admin.billing.state.active': 'Paid until {date}.',
    'admin.billing.state.grace': 'Payment overdue: the admin becomes read-only on {date} (orders keep working).',
    'admin.billing.state.restricted': 'Unpaid subscription: the admin is read-only, except orders, until it is paid.',
    'admin.billing.howToPay': 'Payments are recorded by the beinstore team; the invoice then appears here.',
    'admin.billing.usage': 'Usage',
    'admin.billing.kind.products': 'Products',
    'admin.billing.kind.staff': 'Team members',
    'admin.billing.kind.customDomains': 'Custom domains',
    'admin.billing.usageLine': '{kind}: {used} / {limit}',
    'admin.billing.usageUnlimited': '{kind}: {used} (unlimited)',
    'admin.billing.invoices': 'beinstore invoices',
    'admin.billing.noInvoices': 'No invoices.',
    'admin.billing.invoice': 'Invoice {number} of {date} — {amount} (PDF)',
    'admin.billing.details': 'See the subscription',
    'admin.domains.title': 'Store addresses',
    'admin.domains.intro': 'Your store always stays reachable at its beinstore address. You can also use your own domain name.',
    'admin.domains.unavailable': 'Custom domains are not available on the platform yet.',
    'admin.domains.kind.platform_subdomain': 'beinstore address',
    'admin.domains.kind.custom': 'Custom domain',
    'admin.domains.status.pending_verification': 'awaiting verification',
    'admin.domains.status.active': 'active',
    'admin.domains.canonical': 'main address',
    'admin.domains.host': 'Domain name (e.g. shop.example.tn)',
    'admin.domains.add': 'Add the domain',
    'admin.domains.added': 'Domain added: create the DNS records, then verify.',
    'admin.domains.instructions': 'Create these records with your domain provider:',
    'admin.domains.txt': 'TXT {name} = {value}',
    'admin.domains.cname': 'CNAME {name} → {target}',
    'admin.domains.verify': 'Verify {host}',
    'admin.domains.verified': 'Domain verified.',
    'admin.domains.makeCanonical': 'Use {host} as the main address',
    'admin.domains.canonicalDone': 'Main address changed.',
    'admin.domains.remove': 'Remove {host}',
    'admin.domains.removed': 'Domain removed.',
    'admin.domains.error.notVerified': 'Verification record not found. DNS changes can take a while.',
    'admin.domains.error.invalid': 'Invalid domain name (it must be outside the platform’s domain).',
    'admin.domains.error.taken': 'This domain is already used.',
    'admin.nav.operator': 'Operator console',
    'admin.operator.title': 'Operator console',
    'admin.operator.stores': 'Stores',
    'admin.operator.plans': 'Plans',
    'admin.operator.settings': 'Billing settings',
    'admin.console.tagline': 'Plans, subscriptions and invoices of every store on beinstore.',
    'admin.console.note': 'Reserved for beinstore platform operators.',
    'admin.landing.title': 'Landing page',
    'admin.landing.intro': 'The words of the public page at beinstore.tn. Plans come from the plans offered at sign-up. Empty items are not shown.',
    'admin.landing.language': 'Language being edited',
    'admin.landing.features': 'Features',
    'admin.landing.feature': 'Feature {number}',
    'admin.landing.featureTitle': 'Title ({language})',
    'admin.landing.featureText': 'Text ({language})',
    'admin.landing.addFeature': 'Add a feature',
    'admin.landing.faq': 'Questions and answers',
    'admin.landing.question': 'Question {number}',
    'admin.landing.questionText': 'Question ({language})',
    'admin.landing.answer': 'Answer ({language})',
    'admin.landing.addQuestion': 'Add a question',
    'admin.landing.remove': 'Remove',
    'admin.landing.links': 'Legal pages',
    'admin.landing.terms': 'Terms of use (address)',
    'admin.landing.privacy': 'Privacy policy (address)',
    'admin.landing.linkHint': 'An https address of a page you host. Empty = no link.',
    'admin.landing.saved': 'Landing page saved.',
    'admin.landing.invalid': 'Check the texts and the addresses (https only).',
    'landing.title': 'beinstore — your online store in Tunisia',
    'landing.skip': 'Skip to content',
    'landing.language': 'Language',
    'landing.signIn': 'Sign in',
    'landing.cta': 'Create my store',
    'landing.compare': 'Compare plans',
    'landing.plans': 'Plans',
    'landing.noPlans': 'No plan is available for now.',
    'landing.choose': 'Choose this plan',
    'landing.chooseNamed': 'Choose the {name} plan',
    'landing.free': 'Free',
    'landing.price': '{amount} every {months, plural, one {month} other {# months}}',
    'landing.trial': '{days, plural, one {# day} other {# days}} free trial',
    'landing.limit.products': 'Products: {count}',
    'landing.limit.staff': 'Team members: {count}',
    'landing.limit.domains': 'Custom domains: {count}',
    'landing.unlimited': 'unlimited',
    'landing.features': 'Features',
    'landing.faq': 'Questions and answers',
    'landing.terms': 'Terms of use',
    'landing.privacy': 'Privacy policy',
    'landing.error': 'The page could not be loaded. Try again in a moment.',
    'landing.menu': 'On this page',
    'landing.vision.title': 'Vision',
    'landing.vision.body': 'Every shop in Tunisia should be able to take an order, deliver it and collect the payment in one place, in the language the customer actually reads.',
    'landing.about.title': 'About us',
    'landing.about.body': 'beinstore is that platform. A merchant opens a store, chooses a plan and sells. A customer orders, pays on delivery or by transfer, and follows the order. The store speaks Arabic, French, Tunisian and English.',
    'landing.about.merchantTitle': 'The merchant',
    'landing.about.merchant': 'A merchant opens a store, chooses a plan and sells.',
    'landing.about.customerTitle': 'The customer',
    'landing.about.customer': 'A customer orders, pays on delivery or by transfer, and follows the order.',
    'landing.about.languagesTitle': 'Four languages',
    'landing.about.languages': 'The store is in Arabic, French, Tunisian and English.',
    'landing.contact.title': 'Contact',
    'landing.contact.body': 'A question about a plan or a store: write to us. A merchant who already has a store signs in.',
    'landing.contact.write': 'Write to us',
    'landing.legal.title': 'Policies',
    'landing.legal.termsBody': 'A merchant chooses a plan, then uses beinstore for one store. The price and the trial are the ones shown on this page.',
    'landing.legal.privacyBody': 'We use a merchant’s sign-in details to run their store, and a customer’s order details to deliver it. We do not sell those details.',
    'landing.legal.addressLabel': 'Policy address',
    'landing.footer.product': 'The product',
    'landing.place': 'Tunisia',
    'admin.setup.title': 'Set up your store',
    'admin.setup.progress': 'Step {current} of {total}',
    'admin.setup.steps': 'Steps',
    'admin.setup.done': 'Done',
    'admin.setup.todo': 'To do',
    'admin.setup.optional': 'Optional',
    'admin.setup.required': 'Required',
    'admin.setup.skip': 'Skip this step',
    'admin.setup.continue': 'Continue',
    'admin.setup.saveContinue': 'Save and continue',
    'admin.setup.banner': 'This store is not published yet: shoppers cannot see it.',
    'admin.setup.finish': 'Finish setting up',
    'admin.setup.step.plan': 'Plan',
    'admin.setup.step.contact': 'Contact details',
    'admin.setup.step.legal': 'Legal details',
    'admin.setup.step.delivery': 'Delivery and payment',
    'admin.setup.step.products': 'Products',
    'admin.setup.step.publish': 'Publish',
    'admin.setup.plan.title': 'Choose your plan',
    'admin.setup.plan.none': 'There is no plan to choose for now: continue.',
    'admin.setup.plan.free': 'Free',
    'admin.setup.plan.trial': '{days, plural, one {# day} other {# days}} free trial',
    'admin.setup.plan.limits': 'Products: {products} · Team members: {staff}',
    'admin.setup.plan.unlimited': 'unlimited',
    'admin.setup.plan.locked': 'The store is published or already paid: contact beinstore to change the plan.',
    'admin.setup.contact.title': 'How shoppers reach you',
    'admin.setup.contact.intro': 'Shown at the bottom of every page of your store.',
    'admin.setup.contact.phone': 'Phone',
    'admin.setup.contact.email': 'Contact email',
    'admin.setup.contact.governorate': 'Governorate',
    'admin.setup.contact.choose': 'Choose…',
    'admin.setup.contact.address': 'Address (optional)',
    'admin.setup.contact.governorateMissing': 'Choose your governorate.',
    'admin.setup.legal.title': 'Your legal details',
    'admin.setup.legal.intro': 'Printed on the invoices you give your customers.',
    'admin.setup.legal.name': 'Legal name ({language})',
    'admin.setup.legal.address': 'Registered address ({language})',
    'admin.setup.legal.taxId': 'Tax ID (matricule fiscal)',
    'admin.setup.legal.taxIdHint': 'Optional if you are not registered.',
    'admin.setup.legal.more': 'All invoice settings',
    'admin.setup.delivery.title': 'How customers pay and receive orders',
    'admin.setup.delivery.intro': 'At least one payment method and one way to deliver are needed to take orders.',
    'admin.setup.delivery.incomplete': 'Choose at least one payment method, and store pickup or delivery zones.',
    'admin.setup.delivery.bankInstructions': 'Bank transfer instructions',
    'admin.setup.delivery.shipping': 'Home delivery',
    'admin.setup.delivery.zones': '{count, plural, =0 {No delivery zone yet.} one {# delivery zone.} other {# delivery zones.}}',
    'admin.setup.delivery.zonesLink': 'Set delivery zones and prices by governorate',
    'admin.setup.delivery.pickupAddress': 'Pickup address',
    'admin.setup.products.title': 'Add your first products',
    'admin.setup.products.intro': 'At least one product on sale, with a price and stock, is needed to publish.',
    'admin.setup.products.ready': 'You have a product ready to sell.',
    'admin.setup.products.added': 'Products added',
    'admin.setup.products.form': 'New product',
    'admin.setup.products.name': 'Name',
    'admin.setup.products.price': 'Price (TND)',
    'admin.setup.products.stock': 'Quantity in stock',
    'admin.setup.products.photo': 'Photo (optional)',
    'admin.setup.products.add': 'Add the product',
    'admin.setup.products.more': 'Full product editor',
    'admin.setup.products.invalid': 'Enter a name and a price above zero.',
    'admin.setup.publish.title': 'Publish your store',
    'admin.setup.publish.intro': 'Check it with the preview, then publish: shoppers can then visit it and order.',
    'admin.setup.publish.missing': '{count, plural, one {One required step is not done.} other {# required steps are not done.}}',
    'admin.setup.publish.preview': 'Preview the store',
    'admin.setup.publish.action': 'Publish my store',
    'admin.setup.publish.online': 'Your store is online.',
    'admin.setup.publish.toStore': 'Go to the store dashboard',
    'admin.setup.publish.policies': 'You are the seller. Prohibited goods are not allowed. beinstore can hide a listing or take the store offline.',
    'admin.setup.publish.accept': 'I have read and accept the terms of use and the privacy policy',
    'admin.billing.paymentInstructions': 'How to pay',
    'admin.operator.plan.offered': 'Sign-up',
    'admin.operator.plan.offeredHint': 'Offered to new merchants in the setup wizard',
    'admin.operator.set.paymentInstructionsIn': 'Payment instructions for merchants ({language})',
    'admin.operator.set.paymentInstructionsHint': 'E.g. beinstore’s bank details. Shown on the plan step and the billing page.',
    'admin.operator.set.requiredSteps': 'Steps required before a new store can be published',
    'admin.error.onboarding-incomplete': 'Some required steps are not done yet.',
    'admin.error.terms-not-accepted': 'Accept the terms of use before publishing.',
    'storefront.contact': 'Contact',
    'admin.error.operator-account': 'This is a platform operator account. Sign in on the operator console.',
    'admin.error.merchant-account': 'This account belongs to stores. Platform operators need a dedicated account.',
    'admin.operator.search': 'Search a store',
    'admin.operator.noStores': 'No stores.',
    'admin.operator.stores.intro': 'Every store and its current plan: last payment, renewal and deadline. Search, filter and sort.',
    'admin.operator.planFilter': 'Plan',
    'admin.operator.plan.any': 'Any plan',
    'admin.operator.stateFilter': 'Subscription',
    'admin.operator.state.any': 'Any status',
    'admin.operator.renew': 'Renews',
    'admin.operator.deadline': 'Deadline',
    'admin.operator.lastPayment': 'Last payment',
    'admin.operator.noPayment': 'None',
    'admin.operator.noPlan': 'No plan',
    'admin.operator.stateShort.none': 'No subscription',
    'admin.operator.stateShort.free': 'Free',
    'admin.operator.stateShort.trialing': 'Trial',
    'admin.operator.stateShort.active': 'Up to date',
    'admin.operator.stateShort.grace': 'Overdue',
    'admin.operator.stateShort.restricted': 'Restricted',
    'admin.operator.plan.new': 'New plan',
    'admin.operator.plan.edit': 'Edit {code}',
    'admin.operator.plan.code': 'Code',
    'admin.operator.plan.nameIn': 'Name in {language}',
    'admin.operator.plan.price': 'Price per period (TND)',
    'admin.operator.plan.period': 'Period',
    'admin.operator.plan.months': '{count, plural, one {# month} other {# months}}',
    'admin.operator.plan.trialDays': 'Free trial days',
    'admin.operator.plan.graceDays': 'Grace days after the due date',
    'admin.operator.plan.maxProducts': 'Maximum products (empty = unlimited)',
    'admin.operator.plan.maxStaff': 'Maximum team members (empty = unlimited)',
    'admin.operator.plan.maxDomains': 'Maximum custom domains (empty = unlimited)',
    'admin.operator.plan.active': 'Offered to stores',
    'admin.operator.plan.create': 'Create the plan',
    'admin.operator.plan.saved': 'Plan saved.',
    'admin.operator.plan.error': 'Check the code (unique), name, price and values.',
    'admin.operator.plan.empty': 'No plans yet.',
    'admin.operator.plan.subscribers': 'Subscribed stores',
    'admin.operator.plan.subscriberCount': '{count, plural, one {# store} other {# stores}}',
    'admin.operator.plan.delete': 'Delete this plan',
    'admin.operator.plan.confirmDelete': 'Confirm plan deletion',
    'admin.operator.plan.deleted': 'Plan deleted.',
    'admin.operator.plan.cannotDelete.subscribers': 'Stores are still on this plan. Assign them another plan first.',
    'admin.operator.plan.cannotDelete.payments': 'Payments were recorded against this plan. Unoffer it instead of deleting.',
    'admin.operator.plan.cannotDelete.default': 'This is the plan for new stores. Change it in billing settings first.',
    'admin.operator.set.legalNameIn': 'beinstore legal name ({language})',
    'admin.operator.set.addressIn': 'beinstore address ({language})',
    'admin.operator.set.taxId': 'beinstore tax ID (optional)',
    'admin.operator.set.footerIn': 'Invoice footer ({language}, optional)',
    'admin.operator.set.prefix': 'Invoice number prefix',
    'admin.operator.set.vatRate': 'VAT rate in % (empty = no VAT)',
    'admin.operator.set.pricesIncludeVat': 'Plan prices include VAT',
    'admin.operator.set.defaultPlan': 'Plan for new stores',
    'admin.operator.set.noDefault': 'None (no subscription)',
    'admin.operator.set.saved': 'Settings saved.',
    'admin.operator.assign': 'Apply the plan',
    'admin.operator.assigned': 'Plan applied.',
    'admin.operator.payment': 'Record a payment',
    'admin.operator.periods': 'Number of periods',
    'admin.operator.amount': 'Amount (TND, empty = price × periods)',
    'admin.operator.method': 'Payment method',
    'admin.operator.method.bank_transfer': 'Bank transfer',
    'admin.operator.method.cash': 'Cash',
    'admin.operator.method.other': 'Other',
    'admin.operator.reference': 'Reference (optional)',
    'admin.operator.receivedAt': 'Date received',
    'admin.operator.invoiceLanguage': 'Invoice language',
    'admin.operator.paid': 'Payment recorded, invoice issued.',
    'admin.operator.payments': 'Payments',
    'admin.operator.noPayments': 'No payments.',
    'admin.operator.paymentLine': '{date} — {amount} — {periods, plural, one {# period} other {# periods}} ({from} → {to})',
    'admin.operator.error.settings': 'Enter beinstore’s legal name and address in the billing settings first.',
    'admin.operator.error.noPlan': 'Apply a plan to this store first.',
    'email.shopperCode.subject': 'Your {store} code: {code}',
    'email.shopperCode.heading': 'Your sign-in code',
    'email.shopperCode.intro': 'Use this code to open your account at {store}:',
    'email.shopperCode.expiry': 'It expires in {minutes, plural, one {# minute} other {# minutes}} and can be used only once.',
    'email.shopperCode.ignore': 'If you did not request it, ignore this email: nobody can sign in without this code.',
    'storefront.account.nav': 'My account',
    'storefront.account.signIn': 'Sign in',
    'storefront.account.title': 'My account',
    'storefront.account.orders': 'My orders',
    'storefront.account.addresses': 'My addresses',
    'storefront.account.profile': 'My details',
    'storefront.account.signOut': 'Sign out',
    'storefront.account.phone': 'Phone',
    'storefront.account.email': 'Email',
    'storefront.account.name': 'Full name',
    'storefront.account.sendCode': 'Send a code',
    'storefront.account.code': 'Code from the email',
    'storefront.account.verify': 'Continue',
    'storefront.account.sent': 'If this number can receive a code, it was sent by email.',
    'storefront.account.invalidCode': 'That code is wrong or has expired.',
    'storefront.account.save': 'Save',
    'storefront.account.saved': 'Saved.',
    'storefront.account.emailChange': 'Change email',
    'storefront.account.emailHint': 'A code is sent to the new address.',
    'storefront.account.noOrders': 'No orders yet.',
    'storefront.account.addAddress': 'Add an address',
    'storefront.account.saveAddress': 'Save address',
    'storefront.account.removeAddress': 'Remove',
    'storefront.account.defaultAddress': 'Default address',
    'storefront.account.makeDefault': 'Use as default',
    'storefront.account.addressLimit': 'Ten addresses at most.',
    'storefront.account.cancelOrder': 'Cancel this order',
    'storefront.account.returnRequest': 'Request a return',
    'storefront.account.returnMessage': 'What would you like to return?',
    'storefront.account.returnSend': 'Send the request',
    'storefront.account.returnStatus.requested': 'Request sent, waiting for the shop',
    'storefront.account.returnStatus.accepted': 'Return accepted',
    'storefront.account.returnStatus.declined': 'Request declined',
    'storefront.account.cancelClosed': 'This order can no longer be cancelled.',
    'storefront.account.phoneLocked': 'The phone number does not change.',
    'storefront.account.newAccount': 'First visit: also enter your name and email.',
    'storefront.account.back': 'Back to my orders',
    'storefront.account.cancelled': 'Your order is cancelled.',
    'storefront.account.returnSent': 'Your request was sent.',
    'storefront.account.declineNote': 'Note from the shop: {note}',
    'storefront.account.error': 'That did not work. Try again.',
    'storefront.account.ordered': 'Ordered',
    'storefront.account.payment': 'Payment',
    'storefront.account.delivery': 'Delivery',
    'storefront.account.deliveryDate': 'Delivery date',
    'storefront.account.plannedDelivery': 'Planned delivery',
    'storefront.account.notDelivered': 'Not delivered yet',
    'storefront.account.notScheduled': 'Not set yet',
    'storefront.account.homeDelivery': 'Home delivery — {place}',
    'storefront.account.pickup': 'Store pickup',
    'storefront.account.track': 'Delivery progress',
    'storefront.account.step.placed': 'Received',
    'storefront.account.step.confirmed': 'Confirmed',
    'storefront.account.step.shipped': 'Shipped',
    'storefront.account.step.delivered': 'Delivered',
    'storefront.account.step.cancelled': 'Cancelled',
    'storefront.account.step.returned': 'Returned',
    'storefront.account.items': 'Items',
    'storefront.account.payment.pending': 'Pending',
    'storefront.account.payment.paid': 'Paid',
    'storefront.account.payment.refunded': 'Refunded',
    'storefront.account.returnStep.reason': 'Reason',
    'storefront.account.returnStep.items': 'Which items',
    'storefront.account.returnStep.details': 'Tell the shop more',
    'storefront.account.returnReason.damaged': 'Damaged or not as expected',
    'storefront.account.returnReason.wrong': 'Wrong item',
    'storefront.account.returnReason.mind': 'I changed my mind',
    'storefront.account.returnReason.other': 'Another reason',
    'storefront.account.returnWhole': 'The whole order',
    'storefront.account.returnReasonLabel': 'Reason',
    'storefront.account.returnItemsLabel': 'Items',
    'storefront.account.commentTitle': 'A message about this order',
    'storefront.account.commentHint': 'Only the shop sees this. It is not published.',
    'storefront.account.commentSend': 'Send the message',
    'storefront.account.commentSent': 'Your message was sent to the shop.',
    'admin.order.returnRequest': 'Return request',
    'admin.order.returnRequest.none': 'No return request.',
    'admin.order.returnRequest.acceptHint': 'Recording a return accepts this request.',
    'admin.order.returnRequest.decline': 'Decline the request',
    'admin.order.returnRequest.declineNote': 'Reason for declining',
    'admin.order.returnRequest.message': 'Customer message',
    'admin.order.returnRequest.status.requested': 'Waiting',
    'admin.order.returnRequest.status.accepted': 'Accepted',
    'admin.order.returnRequest.status.declined': 'Declined',
};
//# sourceMappingURL=en.js.map